import Paho from 'paho-mqtt';

let client
let dataInfo
const getAddress = (data) => {
  dataInfo = data
  client = new Paho.Client(`${data.address}`, `${data.client_id}`);
  // client = new Paho.Client(`ws://39.97.110.209:8083/mqtt`, `a1559e7c-8dd8-4780-b952-100cc4797da1-1739413731660`);

}

const connect = (onConnect, onMessage, onError) => {
  client.onConnectionLost = (responseObject) => {
    if (responseObject.errorCode !== 0) {
      onError(responseObject.errorMessage);
    }
  };

  client.onMessageArrived = (message) => {
    const topic = message.destinationName;
    const payload = message.payloadString;
    onMessage(topic, payload);
  };

  const options = {
    timeout: 3,
    onSuccess: onConnect,
    onFailure: onError,
    // userName: dataInfo?.username,
    // passWord: dataInfo?.password
  };
  client.connect(options);
};

const subscribe = (topic, qos) => {
  client.subscribe(topic, { qos });
};

const publish = (topic, payload, qos, retain) => {
  // console.log('发送了', topic, payload, qos, retain);
  client.publish(topic, payload, qos, retain, (state) => { return state });
};

const disconnect = () => {
  client.disconnect();
};

export { getAddress, connect, subscribe, publish, disconnect };